export const splitContentByPageBreak = htmlContent => {
  if (typeof htmlContent !== 'string') {
    return []
  }
  const pageBreakRegex = new RegExp(
    '<div class="page-break" style="page-break-after:always;"><span style="display:none;">&nbsp;</span></div>'
  )

  // Split the content by the page break
  const segments = htmlContent.split(pageBreakRegex)

  // Return the segments
  return segments
}
